import { useSelector } from "@xstate/store-react";
import { hotkeyStore, resolveHotkey } from "./hotkey-store";

export const useHotkeyBindings = () => useSelector(hotkeyStore, (s) => s.context.bindings);

export const useResolvedHotkey = (commandId: string) =>
  useSelector(hotkeyStore, (s) => resolveHotkey(commandId, s.context.bindings));
